export default {
    tabs1: "維修單填寫",
    tabs2: "維修單列表",
    form1: "當前狀態",
    form2: "後台回復",
    form3: "機器名稱",
    form4: "機器型號",
    form5: "機身號碼",
    form6: "是否我司購買",
    form7: "公司名稱",
    form8: "發票號碼",
    form9: "購買日期",
    form10: "是否有維修過",
    form11: "聯繫人",
    form12: "聯繫電話",
    form13: "地址",
    form14: "維修原因",
    radio: "不清楚",
    rule1: "請選擇機器名稱",
    rule2: "請選擇是否我司購買",
    rule3: "請填寫公司名稱",
    rule4: "請選擇是否有維修過",
    rule5: "請填寫聯繫人",
    rule6: "請填寫聯繫電話",
    rule7: "請填寫維修原因",
    rule8: "請填寫聯繫地址",
    rule9: "請閱讀並同意協議",
    table1: "維修單號",
    table2: "提交時間",
    table3: "結束時間",
    table4: "狀態",
    filter1: "等待確認",
    filter2: "正在維修",
    filter3: "維修完成，正在送回",
    filter4: "已結單",
    title: "維修單詳情"
}